import { zip } from '../control-flow/zip';

enum TokenType {
    NUMBER,
    SLASH,
    END,
}

const
    NUMBER = TokenType.NUMBER,
    SLASH = TokenType.SLASH,
    END = TokenType.END;

class Token {
    value: string;
    type: TokenType;

    constructor(value: string, type: TokenType) {
        this.value = value;
        this.type = type;
    }
}

enum TokenizerState {
    SCANNING,
    NUMBER,
}

const whitespace = /\s/;

function *tokenize(text: string): Generator<Token> {
    let
        start = 0,
        state = TokenizerState.SCANNING,
        i = 0;
    for(const char of text) {
        switch(state) {
            case TokenizerState.SCANNING:
                if(char == "/") {
                    yield new Token(char, SLASH);
                }
                else if(whitespace.test(char)) {
                    // no state change; goto next char
                }
                else {
                    start = i;
                    state = TokenizerState.NUMBER;
                }
                break;
            case TokenizerState.NUMBER:
                if(char == "/") {
                    yield new Token(text.slice(start, i), NUMBER);
                    yield new Token(char, SLASH);
                    state = TokenizerState.SCANNING;
                }
                else if(whitespace.test(char)) {
                    yield new Token(text.slice(start, i), NUMBER);
                    state = TokenizerState.SCANNING;
                } else {
                    // no state change; goto next char
                }
                break;
        }
        i++;
    }
    if(state == TokenizerState.NUMBER) {
        yield new Token(text.slice(start, i), NUMBER);
    }
    yield new Token("", END);
}

const match = (tokens: Token[], ...types: TokenType[]): boolean => {
    if(tokens.length != types.length) {
        return false;
    }
    for(const [token, type] of zip(tokens, types)) {
        if(token.type != type) {
            return false;
        }
    }
    return true;
}

/**
 * A division procedure that should never return a NaN on an Infinity,
 * preferring zero instead.
 */
export const safeDivide = (n: number, d: number): number => {
    if(isNaN(n) || isNaN(d)) {
        return 0;
    }
    if(d == 0) {
        return 0
    }
    return n / d;
};

export const parseFraction = (text: string): number => {
    if(text == null) return 0;
    const tokens = Array.from(tokenize(text));
    if(match(tokens, NUMBER, END)) {
        return Number(tokens[0].value);
    }
    else if(match(tokens, NUMBER, SLASH, NUMBER, END)) {
        const
            numerator = Number(tokens[0].value),
            denomenator = Number(tokens[2].value);
        return safeDivide(numerator, denomenator);
    }
    else if(match(tokens, NUMBER, NUMBER, SLASH, NUMBER, END)) {
        const
            whole = Number(tokens[0].value),
            numerator = Number(tokens[1].value),
            denomenator = Number(tokens[3].value);
        if(isNaN(whole)) {
            return 0;
        }
        return whole + safeDivide(numerator, denomenator);
    }
    return 0;
};
export default parseFraction;

window["tokenize"] = tokenize;
window["parseFraction"] = parseFraction;
